/** @module Enums */ /** typedoc */

export enum ShareReactionTypeEnum {
    Like = 'like'
}
